// Actions
export const ARTICLE_FETCH  = '[Article] Fetch'

// Mutations
export const ARTICLE_META   = '[Article] meta'
export const ARTICLE_OBTAIN = '[Article] obtain'
export const ARTICLE_CLEAR  = '[Article] clear'
export const ARTICLE_SET_LOADING = '[Article] set loading'
